/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CartCheckoutSessionVariables = Types.Exact<{
  cartUuid: Types.Scalars['String']
  priceCents: Types.Scalars['Int']
}>

export type CartCheckoutSession = {
  __typename: 'Root'
  cartCheckoutSession: {
    __typename: 'CartCheckoutSessionPayload'
    stripeCheckoutUrl: string | null
    order: { __typename: 'Order'; id: number } | null
    errors: Array<{
      __typename: 'UserError'
      key: string | null
      message: string | null
      fullMessage: string | null
    }> | null
  } | null
}

export const CartCheckoutSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CartCheckoutSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'cartUuid' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'priceCents' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cartCheckoutSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cartUuid' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'cartUuid' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'priceCents' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'priceCents' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'stripeCheckoutUrl' }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'order' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullMessage' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
export type CartCheckoutSessionMutationFn = Apollo.MutationFunction<
  CartCheckoutSession,
  CartCheckoutSessionVariables
>

/**
 * __useCartCheckoutSession__
 *
 * To run a mutation, you first call `useCartCheckoutSession` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartCheckoutSession` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartCheckoutSession, { data, loading, error }] = useCartCheckoutSession({
 *   variables: {
 *      cartUuid: // value for 'cartUuid'
 *      priceCents: // value for 'priceCents'
 *   },
 * });
 */
export function useCartCheckoutSession(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CartCheckoutSession,
    CartCheckoutSessionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CartCheckoutSession,
    CartCheckoutSessionVariables
  >(CartCheckoutSessionDocument, options)
}
export type CartCheckoutSessionHookResult = ReturnType<
  typeof useCartCheckoutSession
>
export type CartCheckoutSessionMutationResult =
  Apollo.MutationResult<CartCheckoutSession>
export type CartCheckoutSessionMutationOptions = Apollo.BaseMutationOptions<
  CartCheckoutSession,
  CartCheckoutSessionVariables
>
